// @flow

import * as React from 'react';
import warning from 'warning';
import classnames from 'classnames';
import Dropdown from './Dropdown';
import Item from './Item';

import type { IconType } from 'components/Icon';

export type BaseNavItem = {|
    icon?: IconType,
    title: React.Node,
    key?: React.Key
|};

export type NavLink = {|
    ...BaseNavItem,
    url?: any,
    onClick?: (event: SyntheticMouseEvent<*>) => void,
    badge?: string
|};

export type NavDropdown = {|
    ...BaseNavItem,
    children?: NavLink[]
|};

export type NavItem = {|
    ...NavDropdown,
    ...NavLink
|};

type Props = {|
    items: NavItem[],
    className?: string
|};

const HeaderNav = ({ items, className = '' }: Props): React.Node => {
    const _items = items.map((item: NavItem, index: number): React.Node => {
        const key = item.key || index;
        const { title, icon } = item;
        const baseProps = { title, icon };

        if (!('children' in item)) {
            const { url, onClick, badge } = item;
            return (
                <Item
                    {...baseProps}
                    key={key}
                    url={url}
                    onClick={onClick}
                    badge={badge}
                />
            );
        }

        warning(
            !('url' in item),
            `Un élément de la navigation header ne peut pas être un dropdown et un lien vers ` +
            `une autre page en même temps, il faut soit spécifier la clé \`children\` soit la ` +
            `clé \`url\`, mais pas les deux en même temps.`
        );

        const { children } = item;
        return <Dropdown {...baseProps} key={key} items={children || []} />;
    });

    const ulClassName = classnames(className, 'HeaderNav');
    return <ul className={ulClassName}>{_items}</ul>;
};

export default HeaderNav;
